import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { getPlannerItemAsync } from "src/api/plannerApi";
import { localize } from "src/l10n";
import { SpintrTypes } from "src/typings";
import { Label, Loader } from "src/ui";
import { getPlannerItemTypeText } from "src/components/Planner/utils";
import moment from "moment";
import { useSelector } from "react-redux";
import "./TinyPlannerItem.scss";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";

interface IProps {
    id: number;
}

function TinyPlannerItem(props: IProps) {
    const { id } = props;

    const isPlannerEnabled = useSelector<Spintr.AppState, boolean>(
        (state) => !!state.app.items?.find((a) => a.id === SpintrTypes.SpintrApp.Planner && a.enabled),
    );

    const [isLoading, setIsLoading] = useState(isPlannerEnabled);
    const [item, setItem] = useState<Spintr.PlannerItem | undefined>(undefined);

    useEffect(() => {
        if (!isPlannerEnabled) {
            return;
        }

        setIsLoading(true);
        setItem(undefined);

        getPlannerItemAsync(id)
            .then((plannerItem) => {
                setItem(plannerItem);
                setIsLoading(false);
            })
            .catch(() => {
                setItem(undefined);
                setIsLoading(false);
            });
    }, [id, isPlannerEnabled]);

    const dateFormat = useMemo(() => (item?.allDayEvent ? "YYYY-MM-DD" : "YYYY-MM-DD HH:mm"), [item?.allDayEvent]);

    if (isLoading) {
        return <Loader />;
    }

    if (!isPlannerEnabled || !item) {
        return (
            <div className="TinyPlannerItem-wrapper no-item">
                <Label>{localize("RattigheterEllerInnehallSaknas")}</Label>
            </div>
        );
    }

    return (
        <div className="TinyPlannerItem-wrapper has-item">
            <Link to={`/goto/${item.id}`} title={localize("Oppna")}>
                <div className="info">
                    <div className="info-row">
                        <Visage2Icon icon="calendar-1" size="medium" />
                        <Label size="h2" color="dark-grey">
                            {item.name}
                        </Label>
                    </div>
                    <div className="info-row">
                        <Label color="grey" size="body-2">
                            {localize("Typ")}:
                        </Label>
                        <Label color="grey" size="body-2">
                            {getPlannerItemTypeText(item.itemType)}
                        </Label>
                    </div>
                    <div className="info-row">
                        <Label color="grey" size="body-2">
                            {localize("Datum")}:
                        </Label>
                        <Label color="grey" size="body-2">
                            {moment(item.startsAt).format(dateFormat)} - {moment(item.endsAt).format(dateFormat)}
                        </Label>
                    </div>
                </div>
                <div className="actions">
                        <Visage2Icon icon="export-3" size="medium" title={localize("Oppna")} />
                </div>
            </Link>
        </div>
    );
}

export default TinyPlannerItem;
